<template>
    <svg viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_25807_116925)">
            <path
                d="M89.5973 0H-5.60273C-11.7883 0 -16.8027 5.01441 -16.8027 11.2V72.8C-16.8027 78.9856 -11.7883 84 -5.60273 84H89.5973C95.7829 84 100.797 78.9856 100.797 72.8V11.2C100.797 5.01441 95.7829 0 89.5973 0Z"
                fill="#FFDA2C"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M-16.8027 0H27.9973V84H-16.8027V0Z"
                fill="#151515"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M55.9961 0H100.796V84H55.9961V0Z"
                fill="#F93939"
            />
        </g>
        <defs>
            <clipPath id="clip0_25807_116925">
                <rect width="84" height="84" rx="42" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "BelgiumFlagIcon",
});
</script>
